<template>
  <q-card
    class="column cursor-pointer position-relative overflow-hidden"
    :class="cardClass"
    :style="cardStyle"
    flat
    bordered
    @click="$emit('click', item)"
  >
    <div>
      <transition
        leave-class="hidden"
        enter-active-class="animated bounceIn"
      >
        <q-badge
          v-if="itemCount"
          :key="itemCount"
          style="font-size: 18px; z-index: 1"
          class="q-py-sm text-bold"
          :color="hideImage ? 'secondary' : 'primary'"
          :text-color="badgeTextColor"
          floating
        >
          x {{ itemCount }}
        </q-badge>
      </transition>
    </div>
    <q-img
      v-if="!!item.imageUrl && !hideImage"
      :src="item.imageUrl"
      :no-spinner="$register"
      :no-transition="$register"
    />
    <age-restricted-banner
      v-if="item.showAlcoholAcknowledgement"
    />
    <q-card-section
      class="column"
      :class="{
        'q-pa-sm': !!item.imageUrl,
        'justify-between q-pa-md': !item.imageUrl
      }"
      :style="{ height: !item.imageUrl ? '100%' : undefined }"
    >
      <div
        class="text-body2 col column text-weight-bolder"
        :class="{
          'column': isMobile && (!item.imageUrl || hideImage),
          'text-center': textCenter,
          'text-left': !textCenter
        }"
        style="line-height: 1.2;"
        :style="{ 'padding-left': (hideImage || !item.imageUrl) && item.showAlcoholAcknowledgement ? '30px' : undefined }"
      >
        <slot name="name">
          {{ itemName || item.name }}
        </slot>
        <div
          v-if="displayPrice && itemPrice !== null"
          class="col text-weight-regular"
        >
          <template v-if="hasExtraCharge">
            {{ $t('pricing.startingAt') }}
          </template>
          <i18n-n
            :value="itemPrice"
            :class="{ 'q-ml-xs': hasExtraCharge }"
            format="currency"
            tag="span"
            scope="global"
          />
        </div>
        <div
          v-else-if="displayPrice"
          class="col text-weight-regular"
          style="min-height: 1.2em;"
        >
          <q-skeleton
            type="text"
            width="60px"
          />
        </div>
      </div>
    </q-card-section>
    <slot name="availability-badge" />
    <slot name="alcohol-dialog" />
    <slot name="sales-dialog" />
  </q-card>
</template>

<script>
import AgeRestrictedBanner from 'src/modules/checkout/components/AgeRestrictedBanner'

export default {
  name: 'CategoryDialogCard',
  components: {
    AgeRestrictedBanner
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    itemWidth: {
      type: String,
      required: false,
      default: '18%'
    },
    dialog: {
      type: Boolean,
      required: false,
      default: true
    },
    hideImage: {
      type: Boolean,
      required: false,
      default: false
    },
    bgColor: {
      type: String,
      required: false,
      default: 'responsive'
    },
    textColor: {
      type: String,
      required: false,
      default: 'responsive'
    },
    isMobile: {
      type: Boolean,
      required: false,
      default: false
    },
    itemName: {
      type: String,
      required: false,
      default: null
    },
    textCenter: {
      type: Boolean,
      required: false,
      default: false
    },
    itemCount: {
      type: Number,
      required: false,
      default: 0
    },
    hasReducedOpacity: {
      type: Boolean,
      required: false,
      default: false
    },
    isTouching: {
      type: Boolean,
      required: false,
      default: false
    },
    badgeTextColor: {
      type: String,
      required: false,
      default: 'white'
    },
    displayPrice: {
      type: Boolean,
      required: false,
      default: true
    },
    itemPrice: {
      type: Number,
      required: false,
      default: null
    },
    hasExtraCharge: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['click'],
  computed: {
    cardClass () {
      return {
        [`bg-${this.bgColor} text-${this.textColor}`]: true,
        'justify-center': this.isMobile && (!this.item.imageUrl || this.hideImage)
      }
    },
    cardStyle () {
      return {
        width: this.itemCount ? `calc(${this.itemWidth} - 6px)` : this.itemWidth,
        'min-height': this.isMobile ? (this.itemCount ? '74px' : '80px') : (this.itemCount ? '144px' : '150px'),
        'max-width': this.dialog || this.$q.screen.lt.sm ? undefined : '135px',
        'flex-shrink': this.$q.screen.gt.sm ? '1' : undefined,
        border: this.itemCount ? '3px solid var(--q-primary)' : undefined,
        opacity: this.hasReducedOpacity ? 0.3 : this.isTouching ? 0.5 : 1
      }
    }
  }
}
</script>

<style scoped lang="scss">
.q-card {
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
}
</style>
